import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { HttpServices } from 'src/app/shared/services/http-service.service';
import { CrewChangeAdminDTO, CrewChangeRequestDTO } from '../models/crewChange.model';

@Injectable({ providedIn: 'root' })
export class CrewChangeService {

  constructor(private http: HttpServices) {
  }


  add(crewChangeRequestDTO: CrewChangeRequestDTO) {
    return this.http.post('CrewChange/Add', crewChangeRequestDTO);
  }
  update(crewChangeRequestDTO: CrewChangeRequestDTO) {
    return this.http.post('CrewChange/Update', crewChangeRequestDTO);
  }
  getById(Id: string) {
    return this.http.get('CrewChange/Get/' +Id);
  }
  AddReviewerDecision(crewChangeAdminDTO: CrewChangeAdminDTO) {
    return this.http.post('CrewChange/AddReviewerDecision', crewChangeAdminDTO);
  }
  AddApprovalDecision(crewChangeAdminDTO: CrewChangeAdminDTO) {
    return this.http.post('CrewChange/AddApprovalDecision', crewChangeAdminDTO);
  }
  AddAgentApprovalDecision(crewChangeAdminDTO: CrewChangeAdminDTO) {
    return this.http.post('CrewChange/AddAgentApprovalDecision', crewChangeAdminDTO);
  }
  getTransitRelatedRequests(IMONO: String) {
    return this.http.get('Transit/GetTransitRelatedRequests?IMONumber=' + IMONO);
  }
  postRequestToSCA(requestId: string) {
    return this.http.get('CrewChange/PostRequestToSCA?requestId=' +requestId);

  }
}